import  { Route, Routes } from "react-router-dom"

import Header from "../Header.jsx"
import FeedPage from "../Feed/FeedPage.tsx"
import SearchPage from "../Search/SearchPage.tsx"
import MapPage from "../Map/Map.tsx"
import CreateEvent from '../CreateEvent/CreateEvent.tsx';
import ProfilePage from '../Profile/ProfilePage.tsx';
import Settings from '../Profile/SettingsPage.tsx';

import SignUp from "../SignUp/SignUp.js"
import SignIn from "../SignIn/SignIn.js"
import Wrapper from '../Wrapper';

const Router = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100dvh' }}>
      <Header />
      <Routes>
        <Route path="/search" element={ <SearchPage />} />
        <Route path="/feed" element={ <FeedPage />} />
        <Route path="" element={<MapPage />} />
        <Route path="/profile/:username" element={<ProfilePage/>}/>
        <Route path="/profile/" element={<Wrapper><ProfilePage /></Wrapper>} />
        <Route path="/create_event" element={<Wrapper><CreateEvent /></Wrapper>} />

        <Route path="/settings" element={<Wrapper><Settings/></Wrapper>}/>
        <Route path="/sign_in" element={<SignIn/>} />
        <Route path="/sign_up" element={<SignUp/>} />
      </Routes>
    </div>
  );
}

export default Router;